import React from 'react';

import PropTypes from 'prop-types';
import { FaArrowRight } from 'react-icons/fa';

import { Heading15, Label6 } from '@src/theme';
import { bemClassName } from '@src/utils/bem';

import { StyledBlogCategoriesList } from './styles';

const b = bemClassName('categories-list');

const BlogCategoriesList = ({ title, categories, onCategoryClick }) => {
  return (
    <StyledBlogCategoriesList>
      <div className={b('title')}>
        <Heading15>{title}</Heading15>
      </div>
      <div className={b('categories')}>
        {categories.map((category) => (
          <div
            key={`category-item-${category.id || category.text}`}
            className={b('categories', 'category')}
            onClick={() => onCategoryClick?.(category.text)}
          >
            <FaArrowRight className={b('categories', 'category', 'icon')} />
            <div className={b('categories', 'category', 'text')}>
              <Label6>{category.text}</Label6>
            </div>
            {category.count && (
              <div className={b('categories', 'category', 'count')}>
                <Label6>({category.count})</Label6>
              </div>
            )}
          </div>
        ))}
      </div>
    </StyledBlogCategoriesList>
  );
};

BlogCategoriesList.propTypes = {
  title: PropTypes.string.isRequired,
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      text: PropTypes.string.isRequired,
      count: PropTypes.number,
    }),
  ).isRequired,
  onCategoryClick: PropTypes.func,
};

export default BlogCategoriesList;
